var map = {
	"./_cards.png": "cfc7",
	"./bank.png": "7620",
	"./btc.png": "c0b3",
	"./card.png": "679c",
	"./card_logos.png": "d3c1",
	"./cards.png": "d656",
	"./cash.png": "e6da",
	"./crypto.png": "7073",
	"./css/milligram.css": "12ac",
	"./donate-embed.png": "d300",
	"./en.png": "70ff",
	"./fonts/CoFoSans-Black.otf": "e998",
	"./fonts/CoFoSans-Medium.otf": "12f3",
	"./fonts/CoFoSans-Regular.otf": "baf4",
	"./fonts/CoFoSans-RegularItalic.otf": "81dd",
	"./global-giving.png": "298f",
	"./iomoney.png": "67fa",
	"./logo.png": "cf05",
	"./paypal.png": "dedf",
	"./psps.png": "5998",
	"./reports.png": "995d",
	"./ru.png": "bf73",
	"./ym.png": "a707",
	"./zaodno-cards.png": "147c",
	"./zaodno.png": "08a3",
	"./zaodno.svg": "b5ac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";